import React, { useContext, useEffect, useState } from "react";
import PageName from "../Utils/PageName";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router-dom";
import { userContext } from "../../context/userContext";
import axios from "axios";
import { environmentVariables } from "../../config/env.config";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import CircularLoader from "../Components/CircularLoader/CircularLoader";
import "./CreateUpdateStyle.css";
import { getUserPermission } from "../../utils/utility";

function Roles() {
  const moduleIdMapsWithPermissionIds = [
    ["1"],
    ["2", "3", "4", "5"],
    ["17", "18"],
    ["25", "27"],
    ["77"],
    [],
    ["6", "7", "8", "9"],
    ["97", "96"],
    ["98"],
    ["84", "87"],
    ["100"],
    ["102", "101"],
    ["104", "103"],
    ["106", "105"],
    ["108", "107"],
    ["110", "109"],
    ["111"],
    ["113", "112"],
    ["115", "114"],
    ["117", "116"],
    ["119", "118"],
    ["121", "120"],
    ["123", "122"],
    ["125", "124"],
    ["127", "126"],
    ["128"],
    ["129"],
    ["130"],
    ["131"],
    ["135"],
    ["133", "132"],
    ["137", "136"],
    ["138"],
    ["140", "139"],
    ["142", "141"],
    ["144", "143"],
    ["145"],
    ["146"],
    ["147"],
    ["149", "148"],
    ["151", "150"],
    ["152"],
    ["153", "154"],
    ["155", "156"],
    ["157"],
    ["158"],
    ["159"],
    ["161", "160"],
    ["162"],
    ["163"],
    ["164", "167"],
    ["165", "166"],
  ];
  const { t } = useTranslation();
  const [roleName, setRoleName] = useState(null);
  const [editedRoleName, setEditedRoleName] = useState("");

  const [moduleIds, setModuleIds] = useState([]);
  const [permissionIds, setPermissionsIds] = useState([]);
  const [roleData, setRoleData] = useState(null);
  const [tempRoleData, setTempRoleData] = useState([]);
  const [roleDataApi, setRoleDataApi] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [error, setError] = useState("");
  const [roleId, setRoleId] = useState(null);
  const { userData, setUserData } = useContext(userContext);
  const [userPermission, setUserPermission] = useState([]);
  const [loader, setLoader] = useState(false);
  const [allUserName, setAllUserName] = useState([]);
  const [isLoader, setIsloader] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [activeUserName, setActiveUserName] = useState("");
  const [limit] = useState(10);

  let userManagePermission = getUserPermission(userData, 106);
  let userViewPermission = getUserPermission(userData, 105);

  useEffect(() => {
    if (userData && userData.id) {
      setUserPermission(userData?.permission);
    }
  }, [userData]);

  const getRoleData = (page = currentPage, resetPagination = false) => {
    const newPage = resetPagination ? 1 : page;

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${environmentVariables?.apiUrl}api/v1/role/rolesPermissionList?page=${newPage}&limit=${limit}&selectedFilterRole=${activeUserName}`,
      headers: {
        _token: userData?.token,
      },
      withCredentials: true,
    };

    axios
      .request(config)
      .then((response) => {
        setIsloader(false);
        setRoleData(response?.data?.data);
        setTotalPages(response.data.pagination.totalPages);
        setTotalRecords(response.data.pagination.totalItems);
        setTempRoleData(response?.data?.data);
        setRoleDataApi(response?.data?.data);

        if (resetPagination) {
          setCurrentPage(1);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getRoleData(currentPage);
  }, [currentPage]);

  useEffect(() => {
    getRoleData(1, true);
  }, [activeUserName]);

  useEffect(() => {
    getAllUserRoleNames();
  }, []);
  const getAllUserRoleNames = async () => {
    try {
      let config = {
        method: "get",
        url: `${environmentVariables?.apiUrl}api/v1/role/getAllRoleUsernames`,
        headers: {
          _token: userData?.token,
        },
        withCredentials: true,
      };


      const response = await axios(config);


      console.log(response.data);
      setAllUserName(response?.data?.usernames);
    } catch (error) {
      console.error('Error fetching user roles:', error);
      throw error;
    }
  };


  const fromRecord = (currentPage - 1) * limit + 1;
  const toRecord =
    currentPage * limit < totalRecords ? currentPage * limit : totalRecords;


  const removeItemfromArray = (
    valueToRemove,
    stateOfArray,
    setStateOfArray
  ) => {

    const newArray = [...stateOfArray];


    const indexToRemove = newArray.indexOf(valueToRemove);

    if (indexToRemove !== -1) {
      newArray.splice(indexToRemove, 1);
      setStateOfArray(newArray);
    }
  };

  const handleRoleSubmit = () => {
    if (roleName == null) {
      toast.error(t("Role_name_mandatory"), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
      return;
    } else if (roleName?.trim() == "") {
      toast.error(t("Role_name_mandatory"), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
      return;

    } else if (roleName?.length > 40 || roleName?.trim()?.length > 40) {
      toast.error(t("Role_name_length"), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
      return;
    }
    if (moduleIds.length === 0) {
      toast.warning(t("Select_Permissions"), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    if (roleName) {
      let data = JSON.stringify({
        name: roleName,
        module_id: moduleIds,
        permission_id: permissionIds,
      });
      setLoader(true);

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${environmentVariables?.apiUrl}api/v1/role/create`,
        headers: {
          "Content-Type": "application/json",
          _token: userData?.token,
        },
        withCredentials: true,
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          if (response) {
            // console.log(response);
            getRoleData();
            setModuleIds([]);
            setPermissionsIds([]);
            setRoleName("");
            setLoader(false);
            toast.success(t("Role_created"), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 1000,
            });
          }
          window.location.reload(5000);
        })
        .catch((error) => {
          // console.log(error.response, "ERERERE");
          setLoader(false);
          toast.error(
            error?.response?.data?.message?.message ||
            error?.response?.data?.message ||
            error?.message,
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 1000,
            }
          );
        });
    } else {
      setError(t("Role_required"));
    }
  };

  const handleRoleEditSubmit = () => {
    if (moduleIds.length === 0) {
      toast.warning(t("Select_Permissions"), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    if (editedRoleName == "" || editedRoleName?.trim() == "") {
      toast.error(t("Role_name_mandatory"), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
      return;
    } else if (editedRoleName?.length > 40 && editedRoleName?.trim()?.length > 40) {
      toast.error(t("Role_name_length"), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
      return;
    }
    // console.log(roleId,"213",moduleIds,"#$%",permissionIds)

    let data = JSON.stringify({
      roleId: roleId,
      module_id: moduleIds,
      permission_id: permissionIds,
      roleName: editedRoleName,
    });
    setLoader(true);
    // console.log(data, "handleRoleEditSubmit");
    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${environmentVariables?.apiUrl}api/v1/role/updateRole`,
      headers: {
        "Content-Type": "application/json",
        _token: userData?.token,
      },
      withCredentials: true,
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        toast.success(t("Role_updated"), {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
        window.location.reload(2000);
        setLoader(false)
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message?.message || error?.response?.data?.message || error?.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
        setLoader(false)
      });
  };

  const handleEditRole = (id) => {
    const roleToBeEdit = roleData.filter((item) => item.role_id == id);

    const newPermissionIds = roleToBeEdit[0]?.permissions.map(
      (val) => `${val?.permission_id}`
    );
    const newmoduleId = roleToBeEdit[0]?.permissions.map(
      (val) => `${val?.module_id}`
    );
    const newModuleSet = new Set([...newmoduleId]);
    // console.log(newModuleSet, "newmoduleset");
    // setRoleName(roleToBeEdit[0]?.role_name);
    setEditedRoleName(roleToBeEdit[0]?.role_name);
    setRoleId(roleToBeEdit[0]?.role_id);
    setPermissionsIds([...newPermissionIds]);
    setModuleIds([...newModuleSet]);
  };

  const handleDeleteRole = (id) => {
    Swal.fire({
      title: `${t("Are_you_sure")}`,
      text: `${t("You_wont_be_able_to_revert_this")}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `${t("Yes_delete_it")}`,
      cancelButtonText: `${t("Cancel")}`,
    }).then((result) => {
      if (result.isConfirmed) {
        let data = JSON.stringify({
          roleId: id,
        });

        let config = {
          method: "delete",
          maxBodyLength: Infinity,
          url: `${environmentVariables?.apiUrl}api/v1/role/deleteRole`,
          headers: {
            "Content-Type": "application/json",
            _token: userData?.token,
          },
          withCredentials: true,
          data: data,
        };

        axios
          .request(config)
          .then((response) => {
            toast.success(t("Selected_role_deleted"), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 1000,
            });
            getRoleData();
          })
          .catch((error) => {
            toast.error(error?.response?.data?.message || error?.message, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 1000,
            });
          });
      }
    });
  };

  const handleCheckedAll = (e) => {
    if (e.target.checked) {
      setModuleIds(["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"]);
      let newPermissionIds = [].concat(...moduleIdMapsWithPermissionIds);
      setPermissionsIds(newPermissionIds);
    } else {
      setModuleIds([]);
      setPermissionsIds([]);
    }
  };

  const handleChangeModule = (e) => {
    // console.log(e.target.checked, "checkbox", e.target.value, "e.target.value");
    let permissionIdOfModuleId =
      moduleIdMapsWithPermissionIds[parseInt(e.target.value) - 1];
    // console.log(moduleIdMapsWithPermissionIds, "module rmissionIds");
    // if(parseInt (e.target.value)==4){
    //   permissionIdOfModuleId=[25,27]
    // }
    // console.log(permissionIdOfModuleId, "permiss uleId!@");
    if (e.target.checked) {
      // console.log("Hello");
      setModuleIds([...moduleIds, `${e.target.value}`]);
      setPermissionsIds([...permissionIds, ...permissionIdOfModuleId]);
    } else {
      // console.log("Hello 1");
      removeItemfromArray(e.target.value, moduleIds, setModuleIds);
      const newPermissionIds = permissionIds.filter(
        (item) => !permissionIdOfModuleId.includes(item)
      );
      setPermissionsIds(newPermissionIds);
    }
  };

  const handleChangePermissions = (e, moduleID) => {
    // console.log(e.target.checked, "e.target.checked", e.target.value);
    let permissionIdOfModuleId =
      moduleIdMapsWithPermissionIds[parseInt(e.target.value) - 1];
    if (e.target.checked) {
      setPermissionsIds([...permissionIds, `${e.target.value}`]);
      if (!moduleIds.includes(moduleID.toString())) {
        setModuleIds([...moduleIds, `${moduleID}`]);
      }
    } else {
      removeItemfromArray(e.target.value, permissionIds, setPermissionsIds);
      setModuleIds(prevModuleIds => prevModuleIds.filter(id => id !== moduleID.toString()));
    }
  };

  const roleSearchByName = () => {
    const filteredResults = roleDataApi.filter((item) =>
      item?.role_name.toLowerCase().includes(searchInput?.toLowerCase())
    );
    setRoleData(filteredResults);
  };

  console.log(userData?.user_type, "inroles==>");


  const handleChangeUserNam = (e) => {
    // console.log(e.target.value, " admin e/.target.value fetch");
    setActiveUserName(e.target.value);
  };
  useEffect(() => {
    getRoleData();
  }, [activeUserName]);

  return (
    <>
      {isLoader ? (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "55%",
            display: "flex",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <CircularLoader size={40} />
        </div>
      ) : (
        <>
          <PageName PageName={t("Roles")} />
          <article>
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-12">
                    {userData && userData?.created_by != 0 && userData?.user_type !== "subAdmin" ? (
                      userPermission &&
                        userPermission.length &&
                        userPermission?.some((obj) =>
                          obj.permissionobj?.name?.includes("create role")
                        ) ? (
                        <p>
                          <a
                            className="btn btn-primary icon-btn"
                            data-bs-toggle="modal"
                            data-bs-target="#newuser"
                            onClick={() => {
                              setRoleName(null);
                              setModuleIds([]);
                              setPermissionsIds([]);
                            }}
                          >
                            Add Role
                          </a>
                        </p>
                      ) : (
                        ""
                      )
                    ) : (
                      <div class="addnewRole_Filterwrapper">
                        {(userData?.user_type === "super_admin" || userData?.user_type === "subAdmin") && (
                          <div class="Contact_filter_fieldbutton_wrapper">
                            <div class="Contact_filter_field_wrapper">
                              <div class="col-md-2 Contact_filter_Inputfield  user-select-items">
                                {/* <h5 className="mb-3">Filter by User name</h5> */}
                                <select
                                  value={activeUserName}
                                  onChange={(e) => handleChangeUserNam(e)}
                                  class="form-select"
                                >
                                  <option value={"All User"}>All User</option>
                                  {allUserName &&
                                    allUserName.length &&
                                    allUserName?.map((el) => {
                                      return <option value={el}>{el} </option>;
                                    })}
                                </select>
                                <div
                                  style={{
                                    fontSize: "14px",
                                    color: "red",
                                    bottom: "70px",
                                  }}
                                ></div>
                              </div>
                            </div>
                          </div>
                        )}
                        {(userData && userData?.created_by == 0 || (userData?.user_type === "super_admin" || userManagePermission)) ?
                          <p className="addrolep">
                            <a
                              className="icon-btn addrolemain_role"
                              data-bs-toggle="modal"
                              data-bs-target="#newuser"
                              onClick={() => {
                                setRoleName(null);
                                setModuleIds([]);
                                setPermissionsIds([]);
                              }}
                            >
                              {t("Add_new_role")} <span className="addrole_role">+</span>
                            </a>
                          </p>
                          : ''}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="tile">
                  <div className="tile-body">
                    <div className="table-responsive">
                      {roleData && roleData.length > 0 ? (
                        <>
                          <table className="table" style={{ border: '0' }}>
                            <thead>
                              <tr>
                                <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                  <th style={{ width: "10%", minWidth: "100px", padding: "10px 0px 15px 0px", fontSize: "15px", marginRight: "10px" }}>
                                    {t("User")}
                                  </th>
                                  <th style={{ width: "10%", minWidth: "100px", padding: "10px 0px 15px 10px", fontSize: "15px", marginRight: "10px" }}>{t("Role")}</th>
                                  <th style={{ width: "100%", minWidth: "300px", maxWidth: "100%", padding: "10px 0px 15px 0px", fontSize: "15px", marginRight: "10px" }}>{t("Permission")}</th>
                                  {(userData?.user_type === "super_admin" || userManagePermission || userData?.created_by == 0) ? <th style={{ width: "10%", minWidth: "100px", padding: "10px 0px 15px 0px", fontSize: "15px" }}>{t("Action")}</th> : ''}
                                </div> </tr>
                            </thead>
                            <tbody>
                              {roleData.map((val, key) => (
                                <tr key={key}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "start",
                                      textAlign: "start",
                                      borderBottom: "1px solid #dedede",
                                      // borderTop:  "1px solid red"
                                    }}
                                  >
                                    <td style={{ width: "10%", minWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "break-spaces", marginRight: "10px" }}>{val?.userName}</td>
                                    <td style={{ width: "10%", minWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "break-spaces", marginRight: "10px" }}>{val.role_name}</td>
                                    <td className="permissionSlotUpdatedStyle" style={{ minWidth: "300px", width: "100%", maxWidth: "100%" }}>
                                      {val?.permissions
                                        ?.filter(
                                          (el) =>
                                            el?.permission_name !== "edit contact" &&
                                            el?.permission_name !== "calendar appointment" &&
                                            el?.permission_name !== "edit appointment" &&
                                            el?.permission_name !== "delete business" &&
                                            el?.permission_name !== "edit business"
                                        )
                                        ?.map((val2, index) => (
                                          <span className="badge rounded m-1 px-3" key={index}>
                                            {val2?.permission_name === "create business"
                                              ? "Manage Business"
                                              : val2?.permission_name === "delete appointment"
                                                ? "Manage Appointment"
                                                : val2?.permission_name === "order physical card"
                                                  ? "View Physical Card"
                                                  : val2?.permission_name === "view analytics business"
                                                    ? "Manage Physical Card"
                                                    : val2?.permission_name}
                                          </span>
                                        ))}
                                    </td>
                                    {(userData?.user_type === "super_admin" || userManagePermission || userData?.created_by == 0) ?
                                      <td style={{ width: "10%", minWidth: "100px" }}>
                                        <div className="btn-group">
                                          {(userData?.user_type === "super_admin" || userManagePermission || userData?.created_by == 0) ?
                                            <button
                                              className="btn btn-warning"
                                              data-bs-toggle="modal"
                                              data-bs-target="#editrols"
                                              onClick={() => handleEditRole(val?.role_id)}
                                            >
                                              <i className="first fas fa-pen fs-5"></i>
                                            </button> : ''}
                                          {(userData?.user_type === "super_admin" || userData?.created_by == 0) &&
                                            <button
                                              className="btn btn-danger"
                                              onClick={() => handleDeleteRole(val?.role_id)}
                                            >
                                              <i className="bi bi-trash fs-5"></i>
                                            </button>}
                                        </div>
                                      </td> : ''}
                                  </div>
                                </tr>
                              ))}
                            </tbody>
                          </table>

                          {/* Pagination Controls */}
                          <div className="pagination" style={{ display: 'flex', justifyContent: 'end', marginRight: '80px', marginTop: '5px' }}>
                            <button
                              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                              disabled={currentPage === 1}
                            >
                              ◀ Previous
                            </button>
                            <span style={{ margin: "10px" }}>
                              {fromRecord} - {toRecord} of {totalRecords}
                            </span>
                            <button
                              onClick={() => setCurrentPage((prev) => (prev < totalPages ? prev + 1 : prev))}
                              disabled={currentPage === totalPages}
                            >
                              Next ▶
                            </button>
                          </div>
                        </>
                      ) : (
                        <p>{t("No_data_available")}</p>
                      )}
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </article>
          <div
            className="modal fade RolesAddNewRoles"
            id="newuser"
            tabindex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"

          >
            <div className="modal-dialog modal-xl modal-style" >
              <div className="modal-content" id="CreateNewRoleSpacingIssueResolved">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    {t("Create_new_role")}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body role_body_style" >
                  <div className="row">
                    <div className="col-12 col-lg-12 mb-2">
                      {/* <label for="exampleFormControlInput1" className="form-label">
                    Role Name
                  </label> */}
                      <input
                        onChange={(e) => setRoleName(e.target.value)}
                        className="form-control"
                        type="text"
                        placeholder={t("Enter_role_name")}
                      />
                    </div>
                    <div
                      style={{
                        color: "red",
                        position: "absolute",
                        top: "92px",
                      }}
                    >
                      {error}
                    </div>
                  </div>

                  <br></br>

                  <table className="table role_body_style" style={{ border: '0' }} >
                    <thead >
                      <tr >
                        <th scope="col">
                          <div className="form-check">
                            {/* <input
                          className="form-check-input"
                          type="checkbox"
                          value="-1"
                          onClick={(e) => handleCheckedAll(e)}
                          id="flexCheckDefault"
                        /> */}
                          </div>
                        </th>
                        <th scope="col">{t("Module")}</th>
                        <th scope="col"> {t("Permissions")}</th>
                      </tr>
                    </thead>

                    <tbody>
                      {/* <tr>
                        <th scope="row" class="check_box_row">
                          {" "}
                          <input
                            className="form-check-input L420"
                            type="checkbox"
                            value="1"
                            id="flexCheckDefault"
                            checked={moduleIds.includes("1") && permissionIds.includes("1")}
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td
                          class="check_box_dashboard"
                          id="check_box_dashboard_id"
                        >
                          {" "}
                          {t("Dashboard")}
                        </td>
                        <td class="check_box_dashboard_id" id="check_box_dashboard_id">
                          <div className="form-check check_box_dashboard CreateUpdateRoleform">
                            <input
                              className="form-check-input "
                              type="checkbox"
                              value="1"
                              checked={permissionIds.includes("1")}
                              id="flexCheckDefault"
                              onChange={(e) => handleChangePermissions(e, 1)}
                            />
                            <label className="form-check-label">{t("View")}</label>
                          </div>
                        </td>
                      </tr> */}

                      <tr>
                        <th
                          scope="row"
                          // class="business_row"
                          class="check_box_row"
                        // style={padding:"10px 0"}
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="3"
                            checked={moduleIds.includes("3") && (permissionIds.includes("17") && permissionIds.includes("18"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id">{t("Business")}</td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ border: "0" }} >
                            <tr>
                              <td >
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="17"
                                    checked={permissionIds.includes("17")}
                                    id="flexCheckDefault"
                                    // onChange={(e) => handleChangePermissions(e)}
                                    onClick={(e) => handleChangePermissions(e, 3)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>{" "}
                              </td>

                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="18"
                                    checked={permissionIds.includes("18")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 3)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>{" "}
                              </td>

                              <td></td>

                              <td></td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th
                          scope="row"
                          // class="physical_card_row_th"
                          class="check_box_row"
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="8"
                            checked={moduleIds.includes("8") && (permissionIds.includes("97") && permissionIds.includes("96"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id">{t("Physical_card")}</td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ border: "0" }}>
                            <tr>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="97"
                                    checked={permissionIds.includes("97")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 8)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>
                              <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="96"
                                    checked={permissionIds.includes("96")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 8)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th
                          scope="row"
                          class="check_box_row"
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="4"
                            checked={moduleIds.includes("4") && (permissionIds.includes("25") && permissionIds.includes("27"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id">{t("Appointment")}</td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ border: "0" }}>
                            <tr>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="25"
                                    checked={permissionIds.includes("25")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 4)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="27"
                                    checked={permissionIds.includes("27")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 4)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th
                          scope="row"
                          // class="physical_card_row_th"
                          class="check_box_row"
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="5"
                            checked={moduleIds?.includes("5") && (permissionIds.includes("77"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Contact")}</td>
                        <td>
                          <table className="table" style={{ border: "0" }}>
                            <tr>
                              <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="77"
                                    checked={permissionIds.includes("77")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 5)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>

                              {/* <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="78"
                                    checked={permissionIds?.includes("78")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 5)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td> */}
                            </tr>
                          </table>
                        </td>
                      </tr>
                      {/* ////////////////////////////////////////// add new role   ///////////////////////////////// */}

                      {(userData?.user_type === "super_admin" || userData?.user_type === "subAdmin") && (
                        <>
                          <tr>
                            <th
                              scope="row"
                              // class="physical_card_row_th"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="11"
                                checked={moduleIds?.includes("11") && (permissionIds.includes("100"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Influencers")}</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="100"
                                        checked={permissionIds.includes("100")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 11)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th
                              scope="row"
                              // class="physical_card_row_th"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="17"
                                checked={moduleIds?.includes("17") && (permissionIds.includes("111"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Influencer_hire_request")}</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="111"
                                        checked={permissionIds.includes("111")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 17)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th
                              scope="row"
                              // class="physical_card_row_th"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="18"
                                checked={moduleIds?.includes("18") && (permissionIds.includes("112") && permissionIds.includes("113"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Influencer_orders")}</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="112"
                                        checked={permissionIds.includes("112")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 18)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="113"
                                        checked={permissionIds?.includes("113")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 18)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th
                              scope="row"
                              // class="physical_card_row_th"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="19"
                                checked={moduleIds?.includes("19") && (permissionIds.includes("114") && permissionIds.includes("115"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Influencer_transactions")}</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="114"
                                        checked={permissionIds.includes("114")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 19)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="115"
                                        checked={permissionIds?.includes("115")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 19)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>


                          <tr>
                            <th
                              scope="row"
                              // class="physical_card_row_th"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="21"
                                checked={moduleIds?.includes("21") && (permissionIds.includes("118") && permissionIds.includes("119"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Product_transactions")}</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="118"
                                        checked={permissionIds.includes("118")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 21)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="119"
                                        checked={permissionIds?.includes("119")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 21)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th
                              scope="row"
                              // class="physical_card_row_th"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="23"
                                checked={moduleIds?.includes("23") && (permissionIds.includes("122") && permissionIds.includes("123"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("coupons")}</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="122"
                                        checked={permissionIds.includes("122")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 23)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="123"
                                        checked={permissionIds?.includes("123")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 23)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th
                              scope="row"
                              // class="physical_card_row_th"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="24"
                                checked={moduleIds?.includes("24") && (permissionIds.includes("124") && permissionIds.includes("125"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Events")}</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="124"
                                        checked={permissionIds.includes("124")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 24)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="125"
                                        checked={permissionIds?.includes("125")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 24)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th
                              scope="row"
                              // class="physical_card_row_th"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="25"
                                checked={moduleIds?.includes("25") && (permissionIds.includes("126") && permissionIds.includes("127"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Custom_plan_enquiries")}</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="126"
                                        checked={permissionIds.includes("126")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 25)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="127"
                                        checked={permissionIds?.includes("127")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 25)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th
                              scope="row"
                              // class="physical_card_row_th"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="26"
                                checked={moduleIds?.includes("26") && (permissionIds.includes("128"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Businessbay_enquiries")}</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="128"
                                        checked={permissionIds.includes("128")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 26)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th
                              scope="row"
                              // class="physical_card_row_th"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="30"
                                checked={moduleIds?.includes("30") && (permissionIds.includes("135"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Add_physical_card")}</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="135"
                                        checked={permissionIds?.includes("135")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 30)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th
                              scope="row"
                              // class="physical_card_row_th"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="33"
                                checked={moduleIds?.includes("33") && (permissionIds.includes("138"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Bulk_upload")}</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="138"
                                        checked={permissionIds?.includes("138")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 33)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th
                              scope="row"
                              // class="physical_card_row_th"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="34"
                                checked={moduleIds?.includes("34") && (permissionIds.includes("139") && permissionIds.includes("140"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Imported_users")}</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="139"
                                        checked={permissionIds.includes("139")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 34)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="140"
                                        checked={permissionIds?.includes("140")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 34)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th
                              scope="row"
                              // class="physical_card_row_th"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="35"
                                checked={moduleIds?.includes("35") && (permissionIds.includes("141") && permissionIds.includes("142"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Settings")}</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="141"
                                        checked={permissionIds.includes("141")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 35)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="142"
                                        checked={permissionIds?.includes("142")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 35)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th
                              scope="row"
                              // class="physical_card_row_th"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="36"
                                checked={moduleIds?.includes("36") && (permissionIds.includes("143") && permissionIds.includes("144"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Manage_ads")}</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="143"
                                        checked={permissionIds.includes("143")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 36)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="144"
                                        checked={permissionIds?.includes("144")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 36)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th
                              scope="row"
                              // class="physical_card_row_th"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="37"
                                checked={moduleIds?.includes("37") && (permissionIds.includes("145"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Create_payment_Link")}</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="145"
                                        checked={permissionIds?.includes("145")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 37)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th
                              scope="row"
                              // class="physical_card_row_th"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="38"
                                checked={moduleIds?.includes("38") && (permissionIds.includes("146"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Mail_template")}</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="146"
                                        checked={permissionIds.includes("146")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 38)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th
                              scope="row"
                              // class="physical_card_row_th"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="27"
                                checked={moduleIds?.includes("27") && (permissionIds.includes("129"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Landing_page_Enquiries")}</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="129"
                                        checked={permissionIds.includes("129")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 27)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th
                              scope="row"
                              // class="physical_card_row_th"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="41"
                                checked={moduleIds?.includes("41") && (permissionIds.includes("150") && permissionIds.includes("151"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("User_login")}</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="150"
                                        checked={permissionIds.includes("150")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 41)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="151"
                                        checked={permissionIds?.includes("151")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 41)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th
                              scope="row"
                              // class="physical_card_row_th"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="12"
                                checked={moduleIds?.includes("12") && (permissionIds.includes("101") && permissionIds.includes("102"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Business_owners")}</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="101"
                                        checked={permissionIds.includes("101")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 12)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="102"
                                        checked={permissionIds?.includes("102")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 12)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="44"
                                checked={moduleIds?.includes("44") && (permissionIds.includes("155") && permissionIds.includes("156"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Wallet_package")}</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="155"
                                        checked={permissionIds.includes("155")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 44)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="156"
                                        checked={permissionIds?.includes("156")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 44)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="47"
                                checked={moduleIds?.includes("47") && (permissionIds.includes("159"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Wallet_history")}</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="159"
                                        checked={permissionIds.includes("159")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 47)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              class="check_box_row"
                            >
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="52"
                                checked={moduleIds?.includes("52") && (permissionIds.includes("165") && permissionIds.includes("166"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> Add Categories</td>
                            <td>
                              <table className="table" style={{ border: "0" }}>
                                <tr>
                                  <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="165"
                                        checked={permissionIds.includes("165")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 52)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="166"
                                        checked={permissionIds?.includes("166")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 52)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </>
                      )}




                      <tr>
                        <th
                          scope="row"
                          // class="physical_card_row_th"
                          class="check_box_row"
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="13"
                            checked={moduleIds?.includes("13") && (permissionIds.includes("103") && permissionIds.includes("104"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Staffs")}</td>
                        <td>
                          <table className="table" style={{ border: "0" }}>
                            <tr>
                              <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="103"
                                    checked={permissionIds.includes("103")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 13)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>

                              <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="104"
                                    checked={permissionIds?.includes("104")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 13)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th
                          scope="row"
                          // class="physical_card_row_th"
                          class="check_box_row"
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="14"
                            checked={moduleIds?.includes("14") && (permissionIds.includes("106") && permissionIds.includes("105"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Roles")}</td>
                        <td>
                          <table className="table" style={{ border: "0" }}>
                            <tr>
                              <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="105"
                                    checked={permissionIds.includes("105")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 14)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>

                              <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="106"
                                    checked={permissionIds?.includes("106")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 14)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th
                          scope="row"
                          // class="physical_card_row_th"
                          class="check_box_row"
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="15"
                            checked={moduleIds?.includes("15") && (permissionIds.includes("107") && permissionIds.includes("108"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Plans")}</td>
                        <td>
                          <table className="table" style={{ border: "0" }}>
                            <tr>
                              <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="107"
                                    checked={permissionIds.includes("107")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 15)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>

                              <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="108"
                                    checked={permissionIds?.includes("108")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 15)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th
                          scope="row"
                          // class="physical_card_row_th"
                          class="check_box_row"
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="22"
                            checked={moduleIds?.includes("22") && (permissionIds.includes("120") && permissionIds.includes("121"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Restaurant_dining_orders")}</td>
                        <td>
                          <table className="table" style={{ border: "0" }}>
                            <tr>
                              <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="120"
                                    checked={permissionIds.includes("120")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 22)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>

                              <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="121"
                                    checked={permissionIds?.includes("121")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 22)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th
                          scope="row"
                          // class="physical_card_row_th"
                          class="check_box_row"
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="48"
                            checked={moduleIds?.includes("48") && (permissionIds.includes("160") && permissionIds.includes("161"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Restaurant_orders")}</td>
                        <td>
                          <table className="table" style={{ border: "0" }}>
                            <tr>
                              <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="160"
                                    checked={permissionIds.includes("160")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 48)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>

                              <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="161"
                                    checked={permissionIds?.includes("161")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 48)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th
                          scope="row"
                          // class="physical_card_row_th"
                          class="check_box_row"
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="28"
                            checked={moduleIds?.includes("28") && (permissionIds.includes("130"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Cab_enquiries")}</td>
                        <td>
                          <table className="table" style={{ border: "0" }}>
                            <tr>
                              <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="130"
                                    checked={permissionIds.includes("130")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 28)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th
                          scope="row"
                          class="check_box_row"
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="49"
                            checked={moduleIds?.includes("49") && (permissionIds.includes("162"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Logistic_enquiry")}</td>
                        <td>
                          <table className="table" style={{ border: "0" }}>
                            <tr>
                              <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="162"
                                    checked={permissionIds.includes("162")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 49)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th
                          scope="row"
                          // class="physical_card_row_th"
                          class="check_box_row"
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="29"
                            checked={moduleIds?.includes("29") && (permissionIds.includes("131"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Mini_market_enquiries")}</td>
                        <td>
                          <table className="table" style={{ border: "0" }}>
                            <tr>
                              <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="131"
                                    checked={permissionIds.includes("131")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 29)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th
                          scope="row"
                          class="check_box_row"
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="50"
                            checked={moduleIds?.includes("50") && (permissionIds.includes("163"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Real_estate_enquiry")}</td>
                        <td>
                          <table className="table" style={{ border: "0" }}>
                            <tr>
                              <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="163"
                                    checked={permissionIds.includes("163")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 50)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th
                          scope="row"
                          // class="physical_card_row_th"
                          class="check_box_row"
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="20"
                            checked={moduleIds?.includes("20") && (permissionIds.includes("116") && permissionIds.includes("117"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Product_orders")}</td>
                        <td>
                          <table className="table" style={{ border: "0" }}>
                            <tr>
                              <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="116"
                                    checked={permissionIds.includes("116")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 20)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>

                              <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="117"
                                    checked={permissionIds?.includes("117")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 20)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th
                          scope="row"
                          // class="physical_card_row_th"
                          class="check_box_row"
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="39"
                            checked={moduleIds?.includes("39") && (permissionIds.includes("147"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Profile")}</td>
                        <td>
                          <table className="table" style={{ border: "0" }}>
                            <tr>
                              <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="147"
                                    checked={permissionIds?.includes("147")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 39)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th
                          scope="row"
                          // class="physical_card_row_th"
                          class="check_box_row"
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="40"
                            checked={moduleIds?.includes("40") && (permissionIds.includes("148") && permissionIds.includes("149"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Order_stats")}</td>
                        <td>
                          <table className="table" style={{ border: "0" }}>
                            <tr>
                              <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="148"
                                    checked={permissionIds.includes("148")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 40)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>

                              <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="149"
                                    checked={permissionIds?.includes("149")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 40)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th
                          scope="row"
                          class="check_box_row"
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="43"
                            checked={moduleIds?.includes("43") && (permissionIds.includes("153") && permissionIds.includes("154"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Wallet_dashboard")}</td>
                        <td>
                          <table className="table" style={{ border: "0" }}>
                            <tr>
                              <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="153"
                                    checked={permissionIds.includes("153")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 43)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>

                              <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="154"
                                    checked={permissionIds?.includes("154")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 43)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th
                          scope="row"
                          class="check_box_row"
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="45"
                            checked={moduleIds?.includes("45") && (permissionIds.includes("157"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Payin_history")}</td>
                        <td>
                          <table className="table" style={{ border: "0" }}>
                            <tr>
                              <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="157"
                                    checked={permissionIds.includes("157")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 45)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th
                          scope="row"
                          class="check_box_row"
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="46"
                            checked={moduleIds?.includes("46") && (permissionIds.includes("158"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Payout_history")}</td>
                        <td>
                          <table className="table" style={{ border: "0" }}>
                            <tr>
                              <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="158"
                                    checked={permissionIds.includes("158")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 46)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th
                          scope="row"
                          class="check_box_row"
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="51"
                            checked={moduleIds?.includes("51") && (permissionIds.includes("164"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Wallet_Withdraw_request")}</td>
                        <td>
                          <table className="table" style={{ border: "0" }}>
                            <tr>
                              <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="164"
                                    checked={permissionIds.includes("164")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 51)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>
                              <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="167"
                                    checked={permissionIds?.includes("167")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 51)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                    <tr>
                        <th
                          scope="row"
                          class="check_box_row"
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="47"
                            checked={moduleIds?.includes("47") && (permissionIds.includes("159"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Wallet_history")}</td>
                        <td>
                          <table className="table" style={{ border: "0" }}>
                            <tr>
                              <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="159"
                                    checked={permissionIds.includes("159")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 47)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>






                      {/* ////////////////////////////////////////// End add new role   ///////////////////////////////// */}

                    </tbody>

                  </table>
                </div>
                <div className="modal-footer">
                  <button
                    onClick={handleRoleSubmit}
                    type="button"
                    className="btn btn-primary save-cta"
                  >
                    {loader ? <CircularLoader /> : `${t("Create")}`}
                  </button>
                  {/* <button
                type="button"
                className="btn btn-secondary close-cta"
                data-bs-dismiss="modal">
                  Close
              </button> */}
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal fade"
            id="editrols"
            tabindex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    {t("Update_role")}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body role_body_style">
                  <div className="row">
                    <div className="col-12 col-lg-12">
                      {/* <label for="exampleFormControlInput1" className="form-label">
                    Role Name
                  </label> */}
                      <input
                        // onChange={(e) => setRoleName(e.target.value)}
                        onChange={(e) => setEditedRoleName(e.target.value)}
                        className="form-control"
                        type="text"
                        // value={roleName}
                        value={editedRoleName}
                        placeholder="Enter Role Name"
                      />
                    </div>
                  </div>
                  {/* <hr /> */}

                  <table className="table" id="role_style_table_id" style={{ borderTop: "none" }}>
                    <thead>
                      <tr>
                        <th scope="col">
                          <div className="form-check" >
                            {/* <input
                          className="form-check-input"
                          type="checkbox"
                          value="-1"
                          onClick={(e) => handleCheckedAll(e)}
                          id="flexCheckDefault"
                        /> */}
                          </div>
                        </th>
                        <th scope="col">{t("Module")}</th>
                        <th scope="col"> {t("Permissions")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* <tr>
                        <th
                          scope="row"
                          // class="physical_card_row_th"
                          class="check_box_row"
                        >
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="1"
                            id="flexCheckDefault"
                            checked={moduleIds.includes("1") && permissionIds.includes("1")}
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td
                          class="check_box_dashboard"
                          id="check_box_dashboard_id"
                        >
                          {" "}
                          {t("Dashboard")}
                        </td>
                        <td class="check_box_dashboard_id" id="check_box_dashboard_id">
                          <div className="form-check check_box_dashboard CreateUpdateRoleform">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value="1"
                              checked={permissionIds.includes("1")}
                              id="flexCheckDefault"
                              onChange={(e) => handleChangePermissions(e, 1)}
                            />
                            <label className="form-check-label">{t("View")}</label>
                          </div>
                        </td>
                      </tr> */}
                      <tr>
                        <th scope="row"
                          // class="physical_card_row_th"
                          class="check_box_row"
                        >
                          {" "}
                          <div >
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value="3"
                              checked={moduleIds.includes("3") && (permissionIds.includes("17") && permissionIds.includes("18"))}
                              id="flexCheckDefault"
                              onChange={(e) => handleChangeModule(e)}
                            />
                          </div>
                        </th>
                        <td
                          class="check_box_dashboard"
                          id="check_box_dashboard_id"
                        >
                          {t("Business")}
                        </td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ borderTop: "none" }}>
                            <tr>
                              <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="17"
                                    checked={permissionIds.includes("17")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 3)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>{" "}
                              </td>

                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="18"
                                    checked={permissionIds.includes("18")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 3)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>{" "}
                              </td>


                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row"
                          class="check_box_row">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="8"
                            checked={moduleIds.includes("8") && (permissionIds.includes("97") && permissionIds.includes("96"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id">{t("Physical_card")}</td>
                        <td >
                          <table className="table" style={{ borderTop: "none" }}>
                            <tr>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="97"
                                    checked={permissionIds.includes("97")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 8)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>
                              <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="96"
                                    checked={permissionIds.includes("96")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 8)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                        {/* <td>
                          <table className="table">
                            <tr>
                              <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                {" "}
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="96"
                                    checked={permissionIds.includes("96")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e)}
                                  />
                                  <label className="form-check-label">
                                    Manage
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td> */}
                      </tr>

                      <tr>
                        <th scope="row" class="check_box_row">
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="4"
                            checked={moduleIds.includes("4") && (permissionIds.includes("27") && permissionIds.includes("25"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id">{t("Appointment")}</td>
                        <td>
                          <table className="table" style={{ borderTop: "none" }}>
                            <tr>
                              <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="25"
                                    checked={permissionIds?.includes("25")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 4)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="27"
                                    checked={permissionIds.includes("27")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 4)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row" class="check_box_row">
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="5"
                            checked={moduleIds.includes("5") && (permissionIds.includes("77"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Contact")} </td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ borderTop: "none" }}>
                            <tr>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="77"
                                    checked={permissionIds.includes("77")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 5)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>

                              {/* <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="78"
                                    checked={permissionIds.includes("78")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 5)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td> */}
                            </tr>
                          </table>
                        </td>
                      </tr>

                      {/* ////////////////////////////////////////// edit new role   ///////////////////////////////// */}


                      {(userData?.user_type === "super_admin" || userData?.user_type === "subAdmin") && (
                        <>
                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="11"
                                checked={moduleIds.includes("11") && (permissionIds.includes("100"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Influencers")} </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="100"
                                        checked={permissionIds.includes("100")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 11)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="17"
                                checked={moduleIds.includes("17") && (permissionIds.includes("111"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Influencer_hire_request")} </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="111"
                                        checked={permissionIds.includes("111")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 17)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="18"
                                checked={moduleIds.includes("18") && (permissionIds.includes("112") && permissionIds.includes("113"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Influencer_orders")} </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="112"
                                        checked={permissionIds.includes("112")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 18)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="113"
                                        checked={permissionIds.includes("113")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 18)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="19"
                                checked={moduleIds.includes("19") && (permissionIds.includes("114") && permissionIds.includes("115"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Influencer_transactions")} </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="114"
                                        checked={permissionIds.includes("114")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 19)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="115"
                                        checked={permissionIds.includes("115")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 19)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>



                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="21"
                                checked={moduleIds.includes("21") && (permissionIds.includes("118") && permissionIds.includes("119"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Product_transactions")} </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="118"
                                        checked={permissionIds.includes("118")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 21)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="119"
                                        checked={permissionIds.includes("119")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 21)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="23"
                                checked={moduleIds.includes("23") && (permissionIds.includes("122") && permissionIds.includes("123"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("coupons")} </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="122"
                                        checked={permissionIds.includes("122")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 23)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="123"
                                        checked={permissionIds.includes("123")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 23)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="24"
                                checked={moduleIds.includes("24") && (permissionIds.includes("124") && permissionIds.includes("125"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Events")} </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="124"
                                        checked={permissionIds.includes("124")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 24)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="125"
                                        checked={permissionIds.includes("125")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 24)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="25"
                                checked={moduleIds.includes("25") && (permissionIds.includes("126") && permissionIds.includes("127"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Custom_plan_enquiries")} </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="126"
                                        checked={permissionIds.includes("126")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 25)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="127"
                                        checked={permissionIds.includes("127")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 25)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="26"
                                checked={moduleIds.includes("26") && (permissionIds.includes("128"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Businessbay_enquiries")} </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="128"
                                        checked={permissionIds.includes("128")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 26)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="27"
                                checked={moduleIds.includes("27") && (permissionIds.includes("129"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Landing_page_Enquiries")} </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="129"
                                        checked={permissionIds.includes("129")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 27)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="30"
                                checked={moduleIds.includes("30") && (permissionIds.includes("135"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Add_physical_card")} </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="135"
                                        checked={permissionIds.includes("135")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 30)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="33"
                                checked={moduleIds.includes("33") && (permissionIds.includes("138"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Bulk_upload")} </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="138"
                                        checked={permissionIds.includes("138")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 33)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="34"
                                checked={moduleIds.includes("34") && (permissionIds.includes("139") && permissionIds.includes("140"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Imported_users")} </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="139"
                                        checked={permissionIds.includes("139")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 34)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="140"
                                        checked={permissionIds.includes("140")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 34)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="35"
                                checked={moduleIds.includes("35") && (permissionIds.includes("141") && permissionIds.includes("142"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Settings")} </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="141"
                                        checked={permissionIds.includes("141")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 35)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="142"
                                        checked={permissionIds.includes("142")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 35)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="36"
                                checked={moduleIds.includes("36") && (permissionIds.includes("143") && permissionIds.includes("144"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Manage_ads")} </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="143"
                                        checked={permissionIds.includes("143")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 36)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="144"
                                        checked={permissionIds.includes("144")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 36)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="37"
                                checked={moduleIds.includes("37") && (permissionIds.includes("145"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Create_payment_Link")} </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="145"
                                        checked={permissionIds.includes("145")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 37)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="38"
                                checked={moduleIds.includes("38") && (permissionIds.includes("146"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Mail_template")} </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="146"
                                        checked={permissionIds.includes("146")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 38)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="41"
                                checked={moduleIds.includes("41") && (permissionIds.includes("150") && permissionIds.includes("151"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("User_login")} </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="150"
                                        checked={permissionIds.includes("150")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 41)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="151"
                                        checked={permissionIds.includes("151")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 41)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="12"
                                checked={moduleIds.includes("12") && (permissionIds.includes("101") && permissionIds.includes("102"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Business_owners")} </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="101"
                                        checked={permissionIds.includes("101")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 12)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="102"
                                        checked={permissionIds.includes("102")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 12)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="44"
                                checked={moduleIds.includes("44") && (permissionIds.includes("155") && permissionIds.includes("156"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Wallet_package")} </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="155"
                                        checked={permissionIds.includes("155")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 44)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="156"
                                        checked={permissionIds.includes("156")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 44)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="47"
                                checked={moduleIds.includes("47") && (permissionIds.includes("159"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> {t("Wallet_history")} </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="159"
                                        checked={permissionIds.includes("159")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 47)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" class="check_box_row">
                              {" "}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="52"
                                checked={moduleIds.includes("52") && (permissionIds.includes("165") && permissionIds.includes("166"))}
                                id="flexCheckDefault"
                                onChange={(e) => handleChangeModule(e)}
                              />
                            </th>
                            <td id="check_box_dashboard_id"> Add Categories </td>
                            <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                              <table className="table" style={{ borderTop: "none" }}>
                                <tr>
                                  <td>
                                    {" "}
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="165"
                                        checked={permissionIds.includes("165")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 52)}
                                      />
                                      <label className="form-check-label">
                                        {t("View")}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="form-check" style={{ borderBottom: "none" }}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="166"
                                        checked={permissionIds.includes("166")}
                                        id="flexCheckDefault"
                                        onChange={(e) => handleChangePermissions(e, 52)}
                                      />
                                      <label className="form-check-label">
                                        {t("Manage")}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </>
                      )}



                      <tr>
                        <th scope="row" class="check_box_row">
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="13"
                            checked={moduleIds.includes("13") && (permissionIds.includes("103") && permissionIds.includes("104"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Staffs")} </td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ borderTop: "none" }}>
                            <tr>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="103"
                                    checked={permissionIds.includes("103")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 13)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>

                              <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="104"
                                    checked={permissionIds.includes("104")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 13)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row" class="check_box_row">
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="14"
                            checked={moduleIds.includes("14") && (permissionIds.includes("105") && permissionIds.includes("106"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Roles")} </td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ borderTop: "none" }}>
                            <tr>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="105"
                                    checked={permissionIds.includes("105")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 14)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>

                              <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="106"
                                    checked={permissionIds.includes("106")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 14)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row" class="check_box_row">
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="15"
                            checked={moduleIds.includes("15") && (permissionIds.includes("107") && permissionIds.includes("108"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Plans")} </td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ borderTop: "none" }}>
                            <tr>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="107"
                                    checked={permissionIds.includes("107")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 15)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>

                              <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="108"
                                    checked={permissionIds.includes("108")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 15)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row" class="check_box_row">
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="22"
                            checked={moduleIds.includes("22") && (permissionIds.includes("120") && permissionIds.includes("121"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Restaurant_dining_orders")} </td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ borderTop: "none" }}>
                            <tr>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="120"
                                    checked={permissionIds.includes("120")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 22)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>

                              <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="121"
                                    checked={permissionIds.includes("121")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 22)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row" class="check_box_row">
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="48"
                            checked={moduleIds.includes("48") && (permissionIds.includes("160") && permissionIds.includes("161"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Restaurant_orders")} </td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ borderTop: "none" }}>
                            <tr>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="160"
                                    checked={permissionIds.includes("160")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 48)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>

                              <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="161"
                                    checked={permissionIds.includes("161")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 48)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row" class="check_box_row">
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="28"
                            checked={moduleIds.includes("28") && (permissionIds.includes("130"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Cab_enquiries")} </td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ borderTop: "none" }}>
                            <tr>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="130"
                                    checked={permissionIds.includes("130")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 28)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row" class="check_box_row">
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="49"
                            checked={moduleIds.includes("49") && (permissionIds.includes("162"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Logistic_enquiry")} </td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ borderTop: "none" }}>
                            <tr>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="162"
                                    checked={permissionIds.includes("162")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 49)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row" class="check_box_row">
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="29"
                            checked={moduleIds.includes("29") && (permissionIds.includes("131"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Mini_market_enquiries")} </td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ borderTop: "none" }}>
                            <tr>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="131"
                                    checked={permissionIds.includes("131")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 29)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row" class="check_box_row">
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="50"
                            checked={moduleIds.includes("50") && (permissionIds.includes("163"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Real_estate_enquiry")} </td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ borderTop: "none" }}>
                            <tr>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="163"
                                    checked={permissionIds.includes("163")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 50)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row" class="check_box_row">
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="20"
                            checked={moduleIds.includes("20") && (permissionIds.includes("116") && permissionIds.includes("117"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Product_orders")} </td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ borderTop: "none" }}>
                            <tr>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="116"
                                    checked={permissionIds.includes("116")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 20)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>

                              <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="117"
                                    checked={permissionIds.includes("117")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 20)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row" class="check_box_row">
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="39"
                            checked={moduleIds.includes("39") && (permissionIds.includes("147"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Profile")} </td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ borderTop: "none" }}>
                            <tr>
                              <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="147"
                                    checked={permissionIds.includes("147")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 39)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row" class="check_box_row">
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="40"
                            checked={moduleIds.includes("40") && (permissionIds.includes("148") && permissionIds.includes("149"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Order_stats")} </td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ borderTop: "none" }}>
                            <tr>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="148"
                                    checked={permissionIds.includes("148")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 40)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>

                              <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="149"
                                    checked={permissionIds.includes("149")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 40)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row" class="check_box_row">
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="43"
                            checked={moduleIds.includes("43") && (permissionIds.includes("153") && permissionIds.includes("154"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Wallet_dashboard")} </td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ borderTop: "none" }}>
                            <tr>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="153"
                                    checked={permissionIds.includes("153")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 43)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>

                              <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="154"
                                    checked={permissionIds.includes("154")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 43)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row" class="check_box_row">
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="45"
                            checked={moduleIds.includes("45") && (permissionIds.includes("157"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Payin_history")} </td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ borderTop: "none" }}>
                            <tr>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="157"
                                    checked={permissionIds.includes("157")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 45)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row" class="check_box_row">
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="46"
                            checked={moduleIds.includes("46") && (permissionIds.includes("158"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Payout_history")} </td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ borderTop: "none" }}>
                            <tr>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="158"
                                    checked={permissionIds.includes("158")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 46)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row" class="check_box_row">
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="51"
                            checked={moduleIds.includes("51") && (permissionIds.includes("164"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Wallet_Withdraw_request")} </td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ borderTop: "none" }}>
                            <tr>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="164"
                                    checked={permissionIds.includes("164")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 51)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>
                              <td>
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="167"
                                    checked={permissionIds.includes("167")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 51)}
                                  />
                                  <label className="form-check-label">
                                    {t("Manage")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                        <tr>
                        <th scope="row" class="check_box_row">
                          {" "}
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="47"
                            checked={moduleIds.includes("47") && (permissionIds.includes("159"))}
                            id="flexCheckDefault"
                            onChange={(e) => handleChangeModule(e)}
                          />
                        </th>
                        <td id="check_box_dashboard_id"> {t("Wallet_history")} </td>
                        <td class="check_box_dashboard_idMid" id="check_box_dashboard_idMid">
                          <table className="table" style={{ borderTop: "none" }}>
                            <tr>
                              <td>
                                {" "}
                                <div className="form-check" style={{ borderBottom: "none" }}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="159"
                                    checked={permissionIds.includes("159")}
                                    id="flexCheckDefault"
                                    onChange={(e) => handleChangePermissions(e, 47)}
                                  />
                                  <label className="form-check-label">
                                    {t("View")}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>


                      {/* ////////////////////////////////////////// edit new role   ///////////////////////////////// */}

                    </tbody>
                  </table>
                </div>
                <div className="modal-footer" style={{ border: "none" }}>
                  {/* <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button> */}
                  <button
                    onClick={handleRoleEditSubmit}
                    type="button"
                    className="btn btn-primary save-cta"
                  >
                    {loader ? <CircularLoader size={25} /> : t("Update")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Roles;
